import React, { useEffect, useState } from "react";
import {
  Card,
  FormControl,
  MenuItem,
  Select,
  TextField,
  Typography,
  IconButton,
} from "@mhome/ui";
import CloseIcon from "@mui/icons-material/Close";
import { useComponentBackgroundColor } from "../common/adaptive-theme-provider";
import { spacingToPx } from "../lib/utils";

const QuickWordsFilter = ({
  sortBy,
  setSortBy,
  setFilterText,
  setShowFilter,
}) => {
  const [searchInput, setSearchInput] = useState("");
  const getComponentBgColor = useComponentBackgroundColor();

  useEffect(() => {
    setFilterText(searchInput);
  });

  const handleSearchInputChange = (event) => {
    setSearchInput(event.target.value);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      // pass
    }
  };

  const handleClose = () => {
    setSearchInput("");
    setShowFilter(false);
  };

  const handleClear = () => {
    setSearchInput("");
    setFilterText("");
  };

  return (
    <Card
      style={{
        marginBottom: spacingToPx(1),
        width: "100%",
        backgroundColor: getComponentBgColor("hsl(var(--card))"),
      }}
      elevation={0}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "8px 12px",
          width: "100%",
          gap: spacingToPx(1.5), // 12px
        }}
      >
        <div style={{ width: "100%" }}>
          <Typography
            variant="caption"
            style={{
              fontWeight: 500,
              color: "hsl(var(--muted-foreground))",
              marginBottom: spacingToPx(0.5),
              display: "block",
            }}
          >
            Quick Command
          </Typography>
          <TextField
            fullWidth
            value={searchInput}
            onChange={handleSearchInputChange}
            onKeyDown={handleKeyDown}
            placeholder="Filter by quick command"
            variant="outlined"
            size="small"
            InputProps={{
              style: {
                padding: "6px 10px",
              },
              endAdornment: searchInput && (
                <IconButton
                  size="small"
                  onClick={handleClear}
                  style={{ marginRight: spacingToPx(-1) }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              ),
            }}
          />
        </div>

        <div style={{ width: "100%" }}>
          <Typography
            variant="caption"
            style={{
              fontWeight: 500,
              color: "hsl(var(--muted-foreground))",
              marginBottom: spacingToPx(0.5),
              display: "block",
            }}
          >
            Sort By
          </Typography>
          <FormControl fullWidth size="small">
            <Select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              variant="outlined"
              style={{
                padding: "6px 10px",
              }}
            >
              <MenuItem value="a-z">Quick commands (A-Z)</MenuItem>
              <MenuItem value="z-a">Quick commands (Z-A)</MenuItem>
            </Select>
          </FormControl>
        </div>
      </div>
    </Card>
  );
};

export default QuickWordsFilter;
